import Grid from '@mui/material/Grid';
import { Tooltip, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { FormSelect } from '../../../../../query-builder/hooks-form-querybuilder/form-select.component';
import FormInput from '../../../../../query-builder/hooks-form-querybuilder/form-input.component';
import { contactApiKeyStore } from '../../../../../../api/contact-api-key-store';
import { PHONENUMBER_FORMAT } from '../../../../../../constants';
import { FormFormattedInput } from '../../../../../../components/hook-form/form-formatted-input.component';
import { Icons } from '../../../../../../assets/icons';
import { FormCheckbox } from '../../../../../../components/hook-form/form-checkbox.component';
import { FormAutoCompleteSelectDynamic } from '../../../../../query-builder/hooks-form-querybuilder/form-autocomplete-select.dynamic.component';
import { customersApiKeyStore } from '../../../../../../api/customers-api-key-store';
import { useFormContext } from 'react-hook-form';


const CONTACT_TITLE = [
  {
    value: 'Mr',
    label: 'Mr',
  },
  {
    value: 'Mrs',
    label: 'Mrs',
  },
  {
    value: 'Ms',
    label: 'Ms',
  },
];

export const ContactForm = () => {
  const { getValues } = useFormContext();
  return (
    <Grid container>
      <Grid container spacing={2}>
        <Grid item lg={7} sm={7} xl={7} xs={7}>
          <Grid container spacing={2}>
            <Grid item lg={6} sm={6} xl={6} xs={6}>
              <Grid container spacing={2}>
                <Grid item lg={3} sm={3} xl={3} xs={3}>
                  <FormSelect name="contactsTitle" label="  Title" options={CONTACT_TITLE} />
                </Grid>
                <Grid item lg={9} sm={9} xl={9} xs={9}>
                  <FormInput name="contactsFirstName" label="First Name" />
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={6} sm={6} xl={6} xs={6}>
              <FormInput name="contactsLastName" label="Last Name" />
            </Grid>
            <Grid item lg={6} sm={6} xl={6} xs={6}>
              <FormInput
                name="contactsWorkEmail"
                label="Work Email"
                validationQueryRoute={(value: any) =>
                  value && contactApiKeyStore.validateContactEmail(getValues('contactsID') ?? 0, value ?? '')
                }
              />
            </Grid>
            <Grid item lg={6} sm={6} xl={6} xs={6}>
              <FormInput
                name="contactsSecondaryEmail"
                label="Secondary Email"
                validationQueryRoute={(value: any) => value && contactApiKeyStore.validateContactEmail(getValues('contactsID') ?? 0, value ?? '')}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item lg={6} sm={6} xl={6} xs={6}>
              <FormFormattedInput name="contactsOfficePhone" label="Office Phone" format={PHONENUMBER_FORMAT} />
            </Grid>
            <Grid item lg={6} sm={6} xl={6} xs={6}>
              <FormInput name="contactsOfficePhoneExt" label="Extension" />
            </Grid>
            <Grid item lg={6} sm={6} xl={6} xs={6}>
              <FormFormattedInput
                name="contactsCellPhone"
                label="Cell Phone"
                format={PHONENUMBER_FORMAT}
                validationQueryRoute={(value: any) =>
                  value && contactApiKeyStore.validateContactPhone(getValues('contactsID') ?? 0, value ?? '')
                }
              />
            </Grid>
            <Grid item lg={6} sm={6} xl={6} xs={6}>
              <FormFormattedInput name="contactsOtherPhone" label="Other Phone" format={PHONENUMBER_FORMAT} />
            </Grid>
            <Grid item lg={6} sm={6} xl={6} xs={6}>
              <FormInput name="contactsOtherPhoneExt" label="Other Phone Extension" />
            </Grid>
            <Grid item lg={6} sm={6} xl={6} xs={6}>
              <FormInput name="specialInstructions" label="Special Instruction" />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                }}
              >
                <FormCheckbox label="Send Report" name="sendReport" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={5} sm={5} xl={5} xs={5}>
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
              {/* <FormInput name="contactsTitle" label="Contact Title/Role" /> */}
              <FormAutoCompleteSelectDynamic
                name="contactRole"
                label="Contact Role"
                getQueryKeyConfig={() => contactApiKeyStore.getContactRoles()}
                optionsValueKey="contactsRoleID"
                optionsLabelKey="contactsRoleName"
              />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
              <FormInput name="contactsDescription" label="Description" multiline size={8.4} />
            </Grid>
            <Grid item lg={4} sm={4} xl={4} xs={4}>
              <FormCheckbox label="Active" name="isActive" />
            </Grid>
            <Grid item lg={5} sm={5} xl={5} xs={5}>
              <FormCheckbox label="Master Contact" name="isMasterContacts" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
